import { useQuery } from "react-query";
import styled from "styled-components";
import React, { useState } from "react";
import { ViewTypeButton } from "./Button";
import { useSelector } from "react-redux";
/* eslint-disable array-callback-return */
import { useTranslation } from "react-i18next";
import Spinner from "@components/Spinner/Spinner";
import AddButton from "@components/Button/AddButton";
import ServerError from "@components/Error/ServerError";
import { Project } from "@styled-icons/octicons/Project";
import { getAllProjects } from "../services/projectCrud";
import Breadcrumb from "@components/Breadcrumb/Breadcrumb";
import { getTrees } from "@modules/Trees/services/treeCrud";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import {
  MapContainer,
  Marker,
  TileLayer,
  ZoomControl,
  FeatureGroup,
  GeoJSON,
  Polygon,
  Popup,
} from "react-leaflet";

import { DropdownWrapper } from "../pages/ProjectDetail/ProjectDetailMapView/MapViewTreeList";
import { parentTreeIcon } from "@helper/marker";
import useChoices from "@hooks/useChoices";
import { getAllIrrigationAreas } from "@modules/IrrigationArea/services/areaCrud";
import ProjectForm from "./Form";

export default function ProjectMapView() {
  const [openForm, setOpenForm] = useState(false);
  const [mapCenter] = useState([48.1558269, 11.5421791]);
  const { mobile } = useSelector((state) => state.mobile);
  const [trees, setTrees] = useState();
  const [areas, setAreas] = useState();
  const { t } = useTranslation();

  const {
    data: projects,
    isLoading,
    isError,
  } = useQuery("projects", getAllProjects, {
    refetchOnWindowFocus: false,
  });
  useQuery("trees", getTrees, {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      setTrees(data.filter((d) => d.health_state == 2));
    },
  });
  useQuery("areas", getAllIrrigationAreas, {
    refetchOnWindowFocus: false,
    retry: false,
    onSuccess: (data) => {
      setAreas(data);
    },
  });
  if (isLoading) return <Spinner height={"80vh"} />;
  if (isError) return <ServerError />;
  return (
    <div>
      <Breadcrumb
        title={`${t("projects")}`}
        addButton={<AddButton label="newproject" action={() => setOpenForm(true)} />}
        viewType={<ViewTypeButton />}
      />
      <Container className="map-view" data-tour="step-2">
        <Row>
          <Col lg={3} className="position-relative ">
            {mobile ? (
              <DropdownWrapper>
                <Dropdown>
                  <Dropdown.Toggle
                    variant="primary"
                    id="dropdown-basic"
                    className="btn btn-primary text-white"
                  >
                    <ProjectIcon />
                  </Dropdown.Toggle>
                  <Dropdown.Menu style={{ zIndex: "9999" }}>
                    <ProjectListMenu projects={projects} />
                  </Dropdown.Menu>
                </Dropdown>
              </DropdownWrapper>
            ) : (
              <>
                <div>
                  <h5 className="mb-4">{t("map_view")}</h5>
                </div>
                <ul className="p-0 m-0 projectMapViewList">
                  <ProjectListMenu
                    projects={projects}
                    // setViewPosition={setViewPosition}
                  />
                </ul>
              </>
            )}
          </Col>
          <Col lg={9}>
            <MapContainer
              center={mapCenter}
              zoom={2}
              scrollWheelZoom={true}
              zoomControl={false}
              style={{ height: "calc(100vh - 160px", borderRadius: "3px" }}
            >
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />
              <ZoomControl position={"bottomright"} />
              {trees?.map((tree) => {
                return (
                  <>
                    {tree.position && (
                      <Marker
                        key={tree.id}
                        position={[tree?.position?.lat, tree?.position?.lng]}
                        icon={parentTreeIcon(tree.health_state)}
                      >
                        {" "}
                        <Popup minWidth={350}>
                          <div className="popup">
                            <Row>
                              <PopupContent tree={tree} />
                            </Row>
                          </div>
                        </Popup>
                      </Marker>
                    )}
                  </>
                );
              })}
              <FeatureGroup>
                {areas?.map((area) => {
                  let position = area.polygon && area.polygon.positions;
                  let indeces = area.polygon && area.polygon.vertices;
                  let filterPosition =
                    area.polygon && position.length > 0 && indeces.map((a) => position[a]);

                  return (
                    <React.Fragment key={area.id}>
                      {area.polygon && position && (
                        <div key={area.id}>
                          <GeoJSON color="purple" data={filterPosition} />
                          <Polygon key={area.id} positions={filterPosition} />
                        </div>
                      )}
                    </React.Fragment>
                  );
                })}
              </FeatureGroup>
            </MapContainer>
          </Col>
        </Row>
      </Container>
      <ProjectForm show={openForm} setOpenForm={setOpenForm} />
    </div>
  );
}
const PopupContent = ({ tree }) => {
  const { t } = useTranslation();
  const [phases] = useChoices("growth_phase");
  const [locations] = useChoices("growth_phase");
  const phase = phases && phases.filter((item) => item.key == tree?.phase);
  const location = locations && locations.filter((item) => item.key == tree?.location);

  return (
    <>
      <Col lg={6} className="px-1">
        <ul className="list-group">
          <li className="list-group-item">
            <b>{t("name")}:</b> {tree.name}
          </li>
          <li className="list-group-item">
            <b>{t("location")}: </b>
            {location && location[0] ? location[0].value : ""}
          </li>
          <li className="list-group-item">
            <b>{t("height")}: </b> {tree.height && tree.height + " m"}
          </li>
        </ul>
      </Col>
      <Col lg={6} className="px-1">
        <ul className="list-group">
          <li className="list-group-item">
            <b>{t("crown_diameter")}: </b>
            {tree.crown_diameter && tree.crown_diameter + " m"}
          </li>
          <li className="list-group-item">
            <b>{t("trunk_circumference")}: </b>
            {tree.trunk_circumference && tree.trunk_circumference + " cm"}
          </li>

          <li className="list-group-item">
            <b>{t("phase")}: </b>
            {phase && phase[0] ? phase[0].value : ""}
          </li>
        </ul>
      </Col>
    </>
  );
};
// function SetViewOnClick({ viewPosition }) {
// 	const map = useMap();
// 	viewPosition && map.setView(viewPosition, map.getZoom());
// 	return null;
// }

const ProjectListMenu = ({ projects }) => {
  // const [activeIndex, setActiveIndex] = useState(1);
  const handleProjectSelect = (project) => {
    // setActiveIndex(project.id);
    let newPoints = [];
    project.polygon.map((polygon) => {
      return newPoints.push({
        lat: parseFloat(polygon.lat),
        lng: parseFloat(polygon.lng),
      });
    });
    if (newPoints.length > 0) {
      // setViewPosition(get_polygon_centroid(newPoints));
    }
  };

  return (
    <>
      {projects?.map((project) => (
        <List
          key={project.id}
          className="d-flex align-items-center clickable border"
          onClick={() => handleProjectSelect(project)}
        >
          <div className="ms-2 d-flex flex-column gap-2">
            <h6 className="mb-1 me-3">{project.name} </h6>
            <div className="d-flex  gap-1">
              <span className="map-view__list__item">{project.areas.length} areas </span>
              <span className="map-view__list__item">{project.trees.length} trees </span>
            </div>
          </div>
        </List>
      ))}
    </>
  );
};

const List = styled.li`
  list-style: none;
  padding: 15px;
  margin-bottom: 10px;
  border-radius: 3px;
`;
const ProjectIcon = styled(Project)`
  width: 14px;
`;
